import { EmployeeProfileRoleDto } from '@/api/generated';

export type RolesDictionariesTranslation = Record<EmployeeProfileRoleDto, string>;

export const rolesDictionariesTranslation: RolesDictionariesTranslation = {
  [EmployeeProfileRoleDto.Admin]: 'Administrator',
  [EmployeeProfileRoleDto.AdminCertification]: 'Administrator certyfikacji',
  [EmployeeProfileRoleDto.AdminDevelopment]: 'Administrator rozwoju',
  [EmployeeProfileRoleDto.AdminSuccession]: 'Administrator sukcesji',
  [EmployeeProfileRoleDto.ForceAccess]: 'Wymuś dostęp',
  [EmployeeProfileRoleDto.HqHrbp]: 'HRBP HQ',
  [EmployeeProfileRoleDto.Hrbp]: 'HRBP',
  [EmployeeProfileRoleDto.NoAccess]: 'Brak dostępu',
  [EmployeeProfileRoleDto.Owner]: 'Właściciel',
  [EmployeeProfileRoleDto.P1]: 'Przełożony',
  [EmployeeProfileRoleDto.P2]: 'Przełożony P2',
};
